import { CheckCircle, Leaf } from "lucide-react";
import styled, { keyframes } from "styled-components";
import { COLORS, EVIAN_COLORS } from "../../utils/Colors";
import { FC } from "react";
import EvianBackground from "../../../assets/evian/success-bg.jpg"; 

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 4rem 0;
  background: url(${EvianBackground}) no-repeat center center;
  background-size: cover;
  animation: ${fadeInUp} 0.6s ease-out;
  overflow-y: auto;
  
  @media (min-width: 1024px) {
    padding: 6rem 0;
  }
`;

const ContentWrapper = styled.div`
  max-width: 56rem;
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;
  
  @media (min-width: 640px) {
    padding: 0 1.5rem;
  }
  
  @media (min-width: 1024px) {
    padding: 0 2rem;
  }
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const IconWrapper = styled.div`
  background-color: ${EVIAN_COLORS.primary};
  padding: 1.5rem;
  border-radius: 0;
`;

const StyledCheckCircle = styled(CheckCircle)`
  height: 4rem;
  width: 4rem;
  color: ${EVIAN_COLORS.panel};
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const MainTitle = styled.h1`
  font-size: 3rem;
  font-weight: 400;
  color: ${COLORS.WHITE};
  
  @media (min-width: 1024px) {
    font-size: 3.75rem;
  }
`;

const Description = styled.p`
  font-size: 1.25rem;
  color: ${COLORS.WHITE};
  max-width: 48rem;
  margin: 0 auto;
  font-weight: 400;
`;

const Card = styled.div`
  background-color: ${EVIAN_COLORS.primary};
  border: 1px solid ${EVIAN_COLORS.primaryHover};
  max-width: 32rem;
  margin: 0 auto;
  border-radius: 0;
`;

const CardContent = styled.div`
  padding: 2rem;
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

const StyledLeaf = styled(Leaf)`
  height: 1.5rem;
  width: 1.5rem;
  color: ${EVIAN_COLORS.panel};
`;

const CardTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 400;
  color: ${EVIAN_COLORS.panel};
`;

const CardText = styled.p`
  color: ${EVIAN_COLORS.panel};
  font-weight: 400;
  max-width: 400px;
`;

export const EvianSuccessScreen: FC = () => {
  return (
    <Container>
      <ContentWrapper>
        <MainContent>
          <IconContainer>
            <IconWrapper>
              <StyledCheckCircle />
            </IconWrapper>
          </IconContainer>

          <TitleSection>
            <MainTitle>
              Entry Confirmed!
            </MainTitle>
            <Description>
              Your entry to the evian F1® Las Vegas Recycling Sweepstakes is confirmed.
              The winner will be randomly selected and contacted directly.
            </Description>
          </TitleSection>

          <Card>
            <CardContent>
              <CardHeader>
                <StyledLeaf />
                <CardTitle>
                  Thank You for Recycling!
                </CardTitle>
              </CardHeader>
              <CardText>
                Every entry celebrates recycling and supports
                evian's journey toward a circular future.
              </CardText>
            </CardContent>
          </Card>
        </MainContent>
      </ContentWrapper>
    </Container>
  );
}
